import React, { Component } from 'react'


class Recientes extends Component {
  render() {
    return(<h3><br/><br/>Estos son los archivos mas recientes</h3>)
    
  }
}

export default Recientes ;


// WEBPACK FOOTER //
// ./src/routes/Recientes.js